// extracted by mini-css-extract-plugin
module.exports = {"page":"layout-module--page--2M1qH","container":"layout-module--container--2TGku","content":"layout-module--content--3nIku"};